import { render, staticRenderFns } from "./ParticipantsManagement.vue?vue&type=template&id=5f552b1a&"
import script from "./ParticipantsManagement.vue?vue&type=script&lang=js&"
export * from "./ParticipantsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports